import PropTypes from 'prop-types';

//Dummy component for AiAssistant
//Will remove this component after the Integration
const AiAssistant = ({ accessToken }) => {
  return <div></div>;
};

AiAssistant.propTypes = {
  accessToken: PropTypes.string
};

export default AiAssistant;
